module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [(_vm.showIfr) ? _c('div', {
    staticClass: "slideWrap"
  }, [_c('iframe', {
    attrs: {
      "id": "iframe1",
      "src": _vm.iframeSrc,
      "frameborder": "0"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, [_c('div', {
    staticClass: "phone"
  }, [_c('span', [_vm._v("+86")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "key"
  }, [_c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "tel",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "focus": _vm.checkPhoneImg,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "getcodeBtn",
    attrs: {
      "disabled": !(_vm.phoneState & _vm.timer)
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.timerstr))])]), _vm._v(" "), _c('div', {
    staticClass: "btnLogin",
    attrs: {
      "disabled": !(_vm.phoneState && _vm.codeState)
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n            登录\n        ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "cover",
    on: {
      "click": _vm.outPop
    }
  }), _vm._v(" "), (_vm.popTips) ? _c('div', {
    staticClass: "tips"
  }, [_c('p', [_vm._v(_vm._s(_vm.tips))]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        (_vm.popTips = false) && (_vm.tips = '')
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('i', {
    on: {
      "click": function($event) {
        (_vm.popTips = false) && (_vm.tips = '')
      }
    }
  }, [_vm._v("x")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            登录即代表您同意\n            "), _c('a', {
    attrs: {
      "href": "https://client.qxiu.com/statement/privacy4.html"
    }
  }, [_vm._v("齐齐服务和隐私条款")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-184b0e33","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/phoneLogin.vue
// module id = 115
// module chunks = 0